import React from 'react'
import { Button } from 'react-bootstrap'

// Import Libraries
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

// Import Components
import Screen from '../../components/accounts/Screen'
import PageTitle from '../../components/accounts/PageTitle'

const TechnicalAssessment = () => {
  return (
    <Screen>
      <Helmet>
        <title>Technical Assessment</title>
      </Helmet>
      <PageTitle title='Technical Assessment' />
      <Link to='/assessment-test'>
        <Button variant='primary'>Start Test</Button>
      </Link>
    </Screen>
  )
}

export default TechnicalAssessment
